import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import type { UpdateHardwareArgs } from 'lib/services';
import { useMutation, type UseMutationResult } from 'react-query';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useUpdateHardware = (
  onSuccess: (data: SerializedHardware) => void,
): UseMutationResult<SerializedHardware, unknown, UpdateHardwareArgs> => {
  const { hardwaresApiClient } = useServices();

  return useMutation((args: UpdateHardwareArgs) => hardwaresApiClient.update(args), {
    mutationKey: MUTATION_KEYS.hardwares.updateOne(),
    onError: error => {
      notifyError(error, {
        message: 'There was an error while updating hardware',
        description: getErrorMessage(error),
      });
    },
    onSuccess: data => {
      notifySuccess({
        message: `Hardware updated`,
      });
      onSuccess(data);
    },
  });
};
